import { useQuery } from '@tanstack/react-query'
import { getShortUsageRequest } from '../../service/list'

function useGetShortUsageRequest(page: number, pageSize: number, type: string) {
  return useQuery({
    queryKey: ['get-short-usage-request'],
    queryFn: () => getShortUsageRequest(page, pageSize, type),
    refetchOnWindowFocus: true,
    retry: false,
    initialData: { totalCount: 0, data: [] },
  })
}

export default useGetShortUsageRequest
